"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconSponsoredEvents = function SvgIconSponsoredEvents(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "sponsored events icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Sponsored Events Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M19.215 20.251h10.084a.75.75 0 00.72-.955 5.869 5.869 0 00-3.795-3.973 4.872 4.872 0 10-3.93.013 6.037 6.037 0 00-3.799 3.96.75.75 0 00.718.961l.002-.006zm-1.65 13.275a4.275 4.275 0 11-8.55 0 4.275 4.275 0 018.55 0zm5.176 3.948a4.275 4.275 0 113.274-7.897 4.275 4.275 0 01-3.274 7.897zm8.203-3.95a4.275 4.275 0 108.55.003 4.275 4.275 0 00-8.55-.003zm4.338 4.359a7.732 7.732 0 016.05 2.896.75.75 0 01-.584 1.221H7.75a.75.75 0 01-.584-1.22 7.732 7.732 0 016.05-2.899 7.736 7.736 0 015.23 2.02.375.375 0 00.5 0 7.981 7.981 0 0110.606 0 .374.374 0 00.5 0 7.737 7.737 0 015.23-2.018zM15.249 25.5a1.5 1.5 0 01-1.061-2.562 1.5 1.5 0 011.061-.44h18a1.5 1.5 0 110 3h-.713a.373.373 0 00-.368.3l-.45 2.241a1.5 1.5 0 11-2.94-.59l.3-1.499a.372.372 0 00-.367-.45h-8.924a.372.372 0 00-.368.45l.3 1.5a1.5 1.5 0 11-2.935.592l-.45-2.242a.373.373 0 00-.368-.3h-.717z"
  }));
};

var _default = SvgIconSponsoredEvents;
exports.default = _default;